import { render, staticRenderFns } from "./TqScoresTable.vue?vue&type=template&id=9203af36&"
import script from "./TqScoresTable.vue?vue&type=script&lang=js&"
export * from "./TqScoresTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports